// extracted by mini-css-extract-plugin
export var divider = "_1d-0";
export var dividerText = "_1d-1";